import {NotifyUserHasChangedUseCase} from './notify-user-has-change.use-case';
import {Injectable} from '@angular/core';
import {ClearCartUseCase} from '@app/core/cart/application/clear-cart.use-case';
import {
    DeleteCurrentDeliveryPointUseCase
} from '@app/core/delivery-point/application/delete-current-delivery-point.use-case';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {UserLocal} from '../domain/user.local';
import {CredentialsStorage} from "@app/core/credentials/domain/credentials-storage";
import {PromoterRepo} from '@app/core/promoter/domain/promoter-repo';


@Injectable({
    providedIn: 'root',
})

export class LogoutUseCase {

    constructor(
        private userLocal: UserLocal,
        private clearCartUseCase: ClearCartUseCase,
        private deleteCurrentDeliveryPointUseCase: DeleteCurrentDeliveryPointUseCase,
        private notifyUserHasChanged: NotifyUserHasChangedUseCase,
        private credentialsStorage: CredentialsStorage,
        private promoterRepo: PromoterRepo,
    ) { }

    /**
     * Deletes the current delivery point, clears the cart, logs out the user, deletes the credentials and notifies the user has changed.
     */
    execute(): Observable<void> {
        return this.clearCartUseCase.execute().pipe(
            tap(() => {
                this.userLocal.logout();
                this.notifyUserHasChanged.execute();
                this.credentialsStorage.deleteCredentials();
                this.deleteCurrentDeliveryPointUseCase.execute();
                this.promoterRepo.delete();
            })
        );
    }

}
